<div class="relative overflow-x-auto @max-w-32 @sm:w-full">
  <table class="@min-w-64 @sm:w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs text-gray-700 uppercase bg-gray-50">
      <tr>
        <th scope="col" class="px-1 py-2 w-1/6">Field</th>
        <th scope="col" class="px-1 py-2 w-1/3">Old</th>
        <th scope="col" class="px-1 py-2 w-1/3">New</th>
      </tr>
    </thead>
    <tbody>
      @for (change of changes; track $index) {
        <tr class="bg-white border-b border-gray-200">
          <td class="px-1 py-1 text-gray-700 whitespace-nowrap align-top">
            <span>{{ change?.fieldName }}</span>
          </td>
          <td class="px-1 py-1 relative group align-top">
            @if (change?.entityIdOld && change?.entityIdOld != '') {
              <span>
                <a (click)="navigateWithId(change, true)" class="cursor-pointer">
                  {{ change?.oldVal }}
                </a>
              </span>
            } @else {
              @for (line of commonUtils.breakIntoLines($safeNavigationMigration(change?.oldVal)); track $index) {
                <div>
                  {{ line }}
                </div>
              }
            }
            @if (change?.oldTooltip?.length ?? 0 > 0) {
              <div
                class="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-amber-600 text-white text-sm font-medium rounded-lg px-2 py-1 z-10 whitespace-nowrap tooltip shadow-xs overflow-x-auto"
              >
                {{ change?.oldTooltip }}
              </div>
            }
          </td>
          <td class="px-1 py-1 relative group align-top">
            @if (change?.entityIdNew && change?.entityIdNew != '') {
              <span>
                <a (click)="navigateWithId(change, false)" class="cursor-pointer">
                  {{ change?.newVal }}
                </a>
              </span>
            } @else {
              @for (line of commonUtils.breakIntoLines($safeNavigationMigration(change?.newVal)); track $index) {
                <div>
                  {{ line }}
                </div>
              }
            }
            @if (change?.newTooltip?.length ?? 0 > 0) {
              <div
                class="absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block bg-amber-600 text-white text-sm font-medium rounded-lg px-2 py-1 z-10 whitespace-nowrap tooltip shadow-xs overflow-x-auto"
              >
                {{ change?.newTooltip }}
              </div>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
